import { render, staticRenderFns } from "./NpaPromotionHistoryDocs.vue?vue&type=template&id=49a36ecc&scoped=true"
import script from "./NpaPromotionHistoryDocs.vue?vue&type=script&lang=js"
export * from "./NpaPromotionHistoryDocs.vue?vue&type=script&lang=js"
import style0 from "./NpaPromotionHistoryDocs.vue?vue&type=style&index=0&id=49a36ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a36ecc",
  null
  
)

export default component.exports